import { render, staticRenderFns } from "./NumberInputValidated.vue?vue&type=template&id=874ad9f8"
import script from "./NumberInputValidated.vue?vue&type=script&lang=js"
export * from "./NumberInputValidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports